import bignumber from 'bignumber.js'

const toFixed = (n, p) => {
  return bignumber(n).toFixed(p || 2)
}

const toSumByFen = (n, p) => {
  return bignumber(n).multipliedBy(0.01).toFormat(2)
}
const toSum = (n, p) => {
  return bignumber(n).toFormat(2)
}

const orgin = n => {
  return bignumber(n)
}

export default {
  install (Vue, options) {
    Vue.prototype.$number = {
      toFixed,
      toSum,
      toSumByFen,
      orgin
    }
  }
}
